import React from 'react';
import { useCart } from '../context/CartContext';
export function Accessories() {
  const {
    addToCart
  } = useCart();
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-369">
      <div className="max-w-[1800px] mx-auto" data-id="element-370">
        <header className="mb-20 text-center" data-id="element-371">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-372">
            The Finishing Touch
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-373">
            Accessories
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-374">
            Jewelry, headwraps, and footwear to complete the Djily Creations
            look.
          </p>
        </header>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-375">
          {['https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1549298916-b41d501d3772?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?auto=format&fit=crop&q=80&w=600'].map((img, i) => (<div key={i} className="aspect-square bg-grey-divider overflow-hidden group relative" data-id="element-376">
                  <img src={img} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" alt="Accessory" data-id="element-377" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-378">
                    <button onClick={() => addToCart({
              id: `accessory-${i}`,
              name: `Accessory Piece ${i + 1}`,
              price: '$120.00',
              image: img,
              quantity: 1,
              size: 'OS'
            })} className="bg-white text-black px-4 py-2 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-379">
                      Add to Bag
                    </button>
                  </div>
                </div>, <div className="mt-2 flex justify-between items-center" data-id="element-380">
                  <span className="text-xs md:text-sm font-display font-bold tracking-widest uppercase" data-id="element-381">
                    Piece {i + 1}
                  </span>
                  <button onClick={() => addToCart({
            id: `accessory-${i}`,
            name: `Accessory Piece ${i + 1}`,
            price: '$120.00',
            image: img,
            quantity: 1,
            size: 'OS'
          })} className="md:hidden text-xs font-display font-bold uppercase tracking-widest border-b border-black" data-id="element-382">
                    Add to Bag
                  </button>
                </div>))}
        </div>
      </div>
    </div>;
}